import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DeviceTypeOPEEnum} from "./DeviceTypeOPEEnum";
import {ProtocolTypeEnum} from "../../enums/registry/ProtocolTypeEnum";

class DeviceTypeDTO {
  id!: number;
  modelName!: string;
  partNumber?: string;
  modbusWritePauseMillis?: number;
  manufacturerName?: string;
  protocolType!: ProtocolTypeEnum;
  label?: string;
}

class O {
  deviceTypes!: DeviceTypeDTO[];
}

/**
 * O Inner Class
 */
class I {
}

export class GetDeviceTypesCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DeviceTypeOPEEnum.GetDeviceTypes);
    this.i = new I();
    this.o = new O();
  }
}
